import { environment } from '../../../environments/environment';

// @ts-ignore
import { JSO } from "jso";

export class OpenIDClient {
  private static _instance: OpenIDClient;
  private provider: any;
  private client: any;

  private constructor() {
    const configFile = {
      client_id: environment.vidClientId,
      token: environment.vidIdentityProvider + "/oauth2/token",
      authorization: environment.vidIdentityProvider + "/oauth2/auth",
      redirect_uri: environment.vidRedirectCallback,
      response_type: "code",
      debug: true,
    };
    this.client = new JSO(configFile);
  }

  public static getInstance(): OpenIDClient {
    return this._instance || (this._instance = new this());
  }

  public getClient(): any {
    return this.client;
  }

  public getProvider(): any {
    return this.provider;
  }
}
